var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllTerrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.267 16.733c.573 0 1.08-.289 1.384-.728h9.604a1.682 1.682 0 002.768 0h.8c.035 0 .07-.008.101-.024l1.455-.728a.228.228 0 00.126-.204v-1.455a.227.227 0 00-.067-.16l-1.455-1.456-2.91-2.911A.228.228 0 0017.91 9H4.083a.228.228 0 00-.203.126l-1.456 2.91-.002.006c-.005.011-.009.023-.012.034l-.004.013a.224.224 0 00-.006.05v2.91c0 .109.076.203.183.224l2.13.426a1.687 1.687 0 001.554 1.034zm0-.455a1.23 1.23 0 01-1.229-1.228 1.23 1.23 0 111.228 1.228zm12.372 0a1.23 1.23 0 010-2.456c.678 0 1.229.55 1.229 1.228a1.23 1.23 0 01-1.229 1.228zm-2.683-6.823h1.861l2.457 2.456h-4.318V9.455zm-4.367 0H15.5v2.456h-3.912V9.455zm-.455 0v2.456H7.286L7.9 9.455h3.234zm-6.91 0H7.43l-.614 2.456H2.996l1.228-2.456z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default SvgAllTerrain;